import { render } from "./footerComponenet.vue?vue&type=template&id=136c2f24&lang=pug"
import script from "./footerComponenet.vue?vue&type=script&lang=js"
export * from "./footerComponenet.vue?vue&type=script&lang=js"

import "./footerComponenet.vue?vue&type=style&index=0&id=136c2f24&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__